import React from 'react';
import i18next from 'i18next';

import type { ViewPageProps } from 'app/main/components/page-layouts';
import type { AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import PhonesView from './view/PhonesView';
import buttons from './PhonesButtons';

import en from './i18n/en';
import it from './i18n/it';

const ViewPage = lazyRetry<ViewPageProps>(() => import('app/main/components/page-layouts/view/ViewPage'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	routes: [
		{
			path: 'phones/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'phones'),
			element: <ViewPage module="phones" content={{ type: 'tabs', tabs: PhonesView }} buttons={buttons.view} />
		}
	]
};

export default routes;
